package com.arena_web.data.dto

import kotlinx.serialization.Serializable

/**
 * Server-side pricing snapshot — mirrors `PricingDto` on the backend. Fetched
 * once per app session via `PricingApi.getPricing()` so the UI can render the
 * live cost of monetised actions without hardcoding.
 */
@Serializable
data class PricingDto(
    val avatarGeneration: String,
    val proEvent: String,
    val currency: String,
)
